/**
 * Um grupo de campos da edição, num Card com título. Os campos vão num grid de duas
 * colunas (uma no mobile); `colSpan: 2` faz um campo ocupar a linha inteira.
 */
import { CampoDinamico, type ValorCampo } from '@/components/crud/CampoDinamico';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { GrupoCampos as TGrupo, RecursoBase } from '@/lib/recursos/tipos';
import { cn } from '@/lib/utils';
import type { Valores } from '@/lib/recursos/formulario';

export function GrupoCampos({
  grupo,
  valores,
  onChange,
}: {
  grupo: TGrupo<RecursoBase>;
  valores: Valores;
  onChange: (chave: string, v: ValorCampo) => void;
}) {
  return (
    <Card className="superficie-vidro relative z-[1]">
      <CardHeader>
        <CardTitle>{grupo.titulo}</CardTitle>
        {grupo.descricao && (
          <p className="text-[13px] leading-[1.5] text-text-secondary">{grupo.descricao}</p>
        )}
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {grupo.campos.map((campo) => (
            <div key={campo.chave} className={cn(campo.colSpan === 2 && 'sm:col-span-2')}>
              <CampoDinamico
                campo={campo}
                valor={valores[campo.chave] ?? ''}
                onChange={(v) => onChange(campo.chave, v)}
                idPrefixo="edit"
              />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
